const ROOT = "/society-management";

const societyManagementPaths = {
  root: ROOT,
  addSociety: `${ROOT}/add-society`,
};

export default societyManagementPaths;
